import { styled } from 'linaria/react';
import { COLORS } from 'styles/constants';

import { StyledWrap as StyledFullBleedWrap, StyledFooter as ImportFooter } from '../FullBleed/styled';

export const StyledWrap = styled(StyledFullBleedWrap)`
  background-position: center;
  background-size: cover;
  gap: 12px;
  min-height: 640px;
  padding: 40px 24px 24px;
  cursor: pointer;
`;

export const StyledFooter = styled(ImportFooter)<{ hasImage: boolean }>`
  padding: 0 12px 0;
  display: flex;
  height: 20px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  align-self: stretch;
`;

export const StyledComment = styled.div`
  padding-top: 0;
`;

export const StyledImage = styled.img<{ isAnimating?: boolean }>`
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 1s ease-in-out;
  width: 100%;
  animation: ${({ isAnimating }) =>
    isAnimating ? 'backgroundImageScale 8.1s cubic-bezier(0.33, 0.00, 0.31, 1.00) infinite' : 'none'};
`;

// Define keyframes for background image animation
const keyframes = `
  @keyframes backgroundImageScale {
    /* Scale up phase: 0s to 2.5s */
    0% {
      transform: scale(1);
    }
    30.9% {
      transform: scale(1.05);
    }
    
    /* Hold at 105%: 2.5s to 3.5s (1 second) */
    30.9% {
      transform: scale(1.05);
    }
    43.2% {
      transform: scale(1.05);
    }
    
    /* Scale down phase: 3.5s to 6.5s (3 seconds) */
    43.2% {
      transform: scale(1.05);
    }
    80.2% {
      transform: scale(1);
    }
    
    /* Hold at 100%: 6.5s to 8.1s (1.6 seconds) */
    80.2% {
      transform: scale(1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

// Inject keyframes into the document
if (typeof document !== 'undefined') {
  // Check if keyframes already exist to avoid duplicates
  const existingStyle = document.querySelector('style[data-background-animation]');
  if (!existingStyle) {
    const style = document.createElement('style');
    style.setAttribute('data-background-animation', 'true');
    style.textContent = keyframes;
    document.head.appendChild(style);
  }
}

export const StyledImageContainer = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &::after {
    bottom: 0;
    background-color: ${COLORS.black[60]};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export const StyledContainer = styled.div`
  overflow: hidden;
  position: relative;

  &:hover {
    img {
      transform: scale(1.2);
    }
  }
`;

export const StyledLink = styled.a`
  margin-top: auto;
  color: ${COLORS.white[100]};
  text-decoration: none;
`;
